

























import Vue from 'vue'
import iconCaretDown from '@/assets/svg/rounded/caret-down.svg?inline'
import CustomCheckbox from '@/components/Common/CustomCheckbox.vue'
import ColumnSorting from '@/components/DataTable/Columns/ColumnSorting.vue'
import { DataTableColumnItem, TableSetting } from '@/models/dataTable'

interface Props {
  keyName: string
  column: string
  allColumns: DataTableColumnItem[]
  tableSetting: TableSetting
  title: string
}

interface Data {
  allCheck: boolean
  showSetting: boolean
  showColumnSort: boolean
  showSorting: boolean
}

interface Computed {
  kanbanName: string
}

export default Vue.extend<Data, {}, Computed, Props>({
  components: {
    CustomCheckbox,
    iconCaretDown,
    ColumnSorting,
  },
  props: {
    keyName: {
      required: true,
    },
    column: {
      required: true,
    },
    allColumns: {
      required: true,
    },
    tableSetting: {
      required: true,
    },
    title: {
      required: true,
    },
  },
  data() {
    return {
      allCheck: false,
      showSetting: false,
      showColumnSort: true,
      showSorting: false,
    }
  },
  computed: {
    kanbanName() {
      switch (this.keyName) {
        case 'target':
          return `${this.$tc('records.' + this.keyName)}: ${this.$tc(
            'records.kanbanTargetValue.' + this.column,
          )}`
        case 'finish_type':
          return `${this.$tc('records.' + this.keyName)}: ${this.column}`
        case 'instance_name':
          return `${this.$tc('records.' + this.keyName)}: ${this.column}`
        case 'user_name':
          return `${this.$tc('records.' + this.keyName)}: ${this.column}`
        default:
          return ''
      }
    },
  },
})
